module.exports = __webpack_public_path__ + "static/media/Search-white.b5be8d37.svg";